import { lazy } from "react";
import i18n from "i18next";
import type { PuzzleTypeModule } from "../types";
import { registerSpellingBeeTranslations } from "./i18n";
import {
  applyVerdict,
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
} from "./progress";
import { emptySolution } from "./solution";
import type {
  SpellingBeeDefinition,
  SpellingBeeProgress,
  SpellingBeeSolution,
  SpellingBeeSubmission,
} from "./types";

registerSpellingBeeTranslations(i18n);

/**
 * No `localFeedback`: the visible rules are enforced as a word is added, and whether a word
 * exists is only known to the server. `applyVerdict` keeps the server's marks on the refused
 * words in the autosaved list, so they stay visible once the list is scored (ADR 0056).
 */
export const spellingBeeModule: PuzzleTypeModule<
  SpellingBeeDefinition,
  SpellingBeeSubmission,
  SpellingBeeProgress,
  SpellingBeeSolution
> = {
  key: "spelling_bee",
  Player: lazy(() => import("./Player")),
  Editor: lazy(() => import("./Editor")),
  SolutionEditor: lazy(() => import("./SolutionEditor")),
  PrintView: lazy(() => import("./PrintView")),
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
  emptySolution,
  applyVerdict,
};
